import type { ScheduleRecalculateEngine } from '../api/schedulingApis';

export const SCHEDULE_RECALC_ENGINE_STORAGE_KEY = 'gantt-planner:schedule-recalc-engine';

/** null = use DHTMLX for manual Recalculate (and skip server recalc after Save). */
export type ScheduleRecalcEnginePreference = ScheduleRecalculateEngine | null;

export function readScheduleRecalcEnginePreference(): ScheduleRecalcEnginePreference {
  if (typeof window === 'undefined') return null;
  const raw = window.localStorage.getItem(SCHEDULE_RECALC_ENGINE_STORAGE_KEY);
  // CPM is disabled in the UI; clear stale preference so Recalculate does not keep using it.
  if (raw === 'CPM') {
    window.localStorage.removeItem(SCHEDULE_RECALC_ENGINE_STORAGE_KEY);
    return null;
  }
  if (raw === 'MPXJ') return raw;
  return null;
}

export function writeScheduleRecalcEnginePreference(
  engine: ScheduleRecalcEnginePreference,
): void {
  if (typeof window === 'undefined') return;
  if (engine == null || engine === 'CPM') {
    window.localStorage.removeItem(SCHEDULE_RECALC_ENGINE_STORAGE_KEY);
    return;
  }
  window.localStorage.setItem(SCHEDULE_RECALC_ENGINE_STORAGE_KEY, engine);
}
